import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  clientMutation,
  clientQuery,
} from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  keyFob: null,
  error: null,
  id: null,
  updateManageKeyFobResult: null,
  drivers: [],
};

const route = "modules/manage/modals/createEditManageKeyFob/redux/slice";

export const manageGetManageKeyFob = createAsyncThunk(
  "manage/createEditManageKeyFob/getManageKeyFob",
  async ({ id }, { rejectWithValue }) => {
    try {
      const query = `
            query ($id: Int!){
                data: getKeyFob(id: $id){
                    id
                    driverId  
                    hex 
                    keyFobModelId
                    driver {
                        title
                    }
                }
            }
        `;
      const response = await clientQuery(
        query,
        { id },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageGetManageKeyFob");
      return rejectWithValue(exc);
    }
  }
);

export const manageCreateEditManageKeyFob = createAsyncThunk(
  "manage/createEditManageKeyFob/createEditManageKeyFob",
  async (payload, { rejectWithValue }) => {
    try {
      const mutation = `
            mutation (
                ${payload.id ? "$id: Int!," : ""}
                $hex: String!,
                $driverId: Int!
            ) {
                data: ${payload.id ? "updateKeyFob" : "createKeyFob"} (
                    ${payload.id ? "id: $id," : ""}
                    hex: $hex,
                    driverId: $driverId
                ) {
                    id
                    driverId  
                    hex 
                    keyFobModelId
                    driver {
                        title
                    }
                }
            }
        `;
      const response = await clientMutation(
        mutation,
        payload,
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageCreateEditManageKeyFob");
      return rejectWithValue(exc);
    }
  }
);

const manageCreateEditManageKeyFobRedux = createSlice({
  name: "manage/createEditManageKeyFob",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalCreateEditManageKeyFob(state, action) {
      state.open = true;
      state.keyFob = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageGetManageKeyFob
    builder.addCase(manageGetManageKeyFob.pending, (state) => {
      state.loading = true;
      state.keyFob = null;
    });
    builder.addCase(manageGetManageKeyFob.fulfilled, (state, action) => {
      state.loading = false;
      state.keyFob = action.payload;
    });
    builder.addCase(manageGetManageKeyFob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //manageCreateEditManageKeyFob
    builder.addCase(manageCreateEditManageKeyFob.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageCreateEditManageKeyFob.fulfilled, (state, action) => {
      state.loading = false;
      state.updateManageKeyFobResult = action.payload;
    });
    builder.addCase(manageCreateEditManageKeyFob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCreateEditManageKeyFobRedux;

// Extract and export each action creator by name
export const { reset, openModalCreateEditManageKeyFob } = actions;

// Export the reducer, either as a default or named export
export default reducer;
